/**
 * Tokens da marca PO27 (spec §7.4).
 *
 * O verde `#92FFB0` tem contraste 1,2:1 sobre branco: ele é preenchimento,
 * borda e ícone — nunca cor de texto sobre fundo claro. No tema escuro ele pode
 * ser texto, porque sobre `#1D1D1D` o contraste passa de 4,5:1.
 */
export const brand = {
  accent: '#92FFB0',
  ink: '#1D1D1D',
  white: '#FFFFFF',
  offWhite: '#FAFAFA',
} as const

export const textColors = {
  dark: { primary: '#FFFFFF', secondary: '#B0B0B0' },
  light: { primary: '#161616', secondary: '#6B6B6B' },
} as const

/** Cores funcionais; iguais nos dois temas. */
export const functional = {
  success: '#2E7D32',
  warning: '#ED6C02',
  error: '#C62828',
  info: '#455A64',
} as const

export const surfaces = {
  dark: {
    default: brand.ink,
    paper: 'rgba(255, 255, 255, 0.04)',
    border: 'rgba(146, 255, 176, 0.12)',
  },
  light: {
    default: brand.offWhite,
    paper: brand.white,
    border: 'rgba(22, 22, 22, 0.10)',
  },
} as const

/** Filete verde curto sob o título de seção. */
export const RULE = { width: 64, height: 4 } as const

export const FONT_FAMILY = '"Barlow", "Helvetica Neue", Arial, sans-serif'
